__turbopack_context__.v({
  "Button": "Bk1nPa_Button",
  "Category": "Bk1nPa_Category",
  "CategoryList": "Bk1nPa_CategoryList",
  "Content": "Bk1nPa_Content",
  "HasMultiple": "Bk1nPa_HasMultiple",
  "Header": "Bk1nPa_Header",
  "Item": "Bk1nPa_Item",
  "Label": "Bk1nPa_Label",
  "Link": "Bk1nPa_Link",
  "List": "Bk1nPa_List",
  "NoResults": "Bk1nPa_NoResults",
  "NoResultsText": "Bk1nPa_NoResultsText",
  "NoResultsTitle": "Bk1nPa_NoResultsTitle",
  "Root": "Bk1nPa_Root",
  "Text": "Bk1nPa_Text",
  "Title": "Bk1nPa_Title",
  "TitleCount": "Bk1nPa_TitleCount",
  "skeleton-loading": "Bk1nPa_skeleton-loading",
});
